export default __webpack_public_path__ + "static/shipping-2-5294381188133b20201d21beecec8cab.jpg";